import { api } from '@/services';

export interface ListaEventosFiltro {
  TipoDocumento: string;
  ChaveAcessoDOC: string;
}

/** As datas chegam como `dd/MM/yyyy HH:mm:ss`, no horário de Brasília. */
export interface EventoDocumento {
  Chave: string;
  Descricao: string;
  CodigoResposta: string | null;
  MensagemResposta: string | null;
  DocumentoAutor: string | null;
  DataHoraEnvio: string;
  DataHoraRecibo: string | null;
  DataExclusao: string | null;
  Origem: string;
  ProtocoloSefaz: string | null;
  /** A linha é a liberação da nota no Recebimento, não um evento da SEFAZ (SPEC-018, §3, item 5). */
  LiberacaoNoRecebimento?: boolean;
}

export interface ListaEventosResponse {
  status: { resultado: boolean; mensagem: string };
  data: EventoDocumento[];
}

export async function fetchListaEventosDocumentos(
  filtro: ListaEventosFiltro
): Promise<ListaEventosResponse> {
  return api.post<ListaEventosResponse, ListaEventosFiltro>(
    'TurboPro/DocumentosFiscais/ListaEventos',
    filtro
  );
}
